<template>
  <transition name="slide-fade">
    <div class="content" v-if="show">
      <b-container class="bv-example-row bv-example-row-flex-cols">
        <b-row class="justify-content-md-center textCentred">
            <b-col cols="12" sm="12" md="12" lg="12" align-v="center">
            <img src="../assets/img/profile.png">
            </b-col>
        </b-row>
        <b-row align-v="center">
            <b-col cols="12" sm="12" md="12" lg="12">
              <p class="sign">Hi my name is...</p>
              <p class="separator">&mdash; &#x2022; &mdash;</p>
            </b-col>
        </b-row>
        <b-row align-v="center">
            <b-col cols="12" sm="12" md="12" lg="12">
              <p class="greetingText">At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id</p>
              <p class="greetingText">At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id</p>
            </b-col>
        </b-row>
        <b-row class="justify-content-md-center imgCentred">
            <b-col cols="12" sm="12" md="2" lg="2">
            <img src="../assets/img/sign.png">
            </b-col>
        </b-row>

        <b-row class="justify-content-md-center mb-5 cf">
          <b-col cols="2" sm="2" md="1" lg="1" v-for="item in media" :key="item.id">
            <a :href="item.url" :title="item.title"><img :src="item.imgWhite"><img class="top" :src="item.imgHover"></a>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </transition>
</template>

<script>
export default {
  data () {
    return {
      media: [
        { url: 'https://www.facebook.com/', title: 'facebook', imgWhite: require('../assets/img/fbWhite.png'), imgHover: require('../assets/img/fbHover.png') },
        { url: 'https://twitter.com/', title: 'tweeter', imgWhite: require('../assets/img/tweeterWhite.png'), imgHover: require('../assets/img/tweeterHover.png') },
        { url: 'https://plus.google.com/discover', title: 'google plus', imgWhite: require('../assets/img/googleWhite.png'), imgHover: require('../assets/img/googleHover.png') },
        { url: 'http://hexagon.com/news/social-media', title: 'hexagon', imgWhite: require('../assets/img/hexagonWhite.png'), imgHover: require('../assets/img/hexagonWhite.png') },
        { url: 'https://pl.pinterest.com/', title: 'pinterest', imgWhite: require('../assets/img/picsaWhite.png'), imgHover: require('../assets/img/pinterestHover.png') },
        { url: 'https://github.com/features', title: 'github', imgWhite: require('../assets/img/gitWhite.png'), imgHover: require('../assets/img/gitWhite.png') }
      ],
      show: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .cf img {
    position:absolute;
    left:0;
    -webkit-transition: opacity 1s ease-in-out;
    -moz-transition: opacity 1s ease-in-out;
    -o-transition: opacity 1s ease-in-out;
    transition: opacity 1s ease-in-out;
  }

  .cf img.top:hover {
    opacity:0;
  }

  .slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(300px);
  opacity: 0;
}

  .separator {
    text-align: center;
    color: #e8e8e8;
  }
  .imgCentred {
    text-align: center!important;
    margin-bottom: 20px;
  }
  .textCentred {
    text-align: center!important;
  }
  .content {
    margin-top: 150px;
    background-color: #ffffff;
  }
  .sign {
    font-family: 'Playfair Display', serif;
    font-size: 30px;
    font-style: italic;
    text-align: center;
    margin-top: 15px;
  }
  .greetingText {
    font-family: 'Raleway Medium', serif;
    font-size: 12px;
    font-style: italic;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/About.vue?96da70b8